export default __webpack_public_path__ + "static/media/surgical-mask.be2da847.jpg";